import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Spinner, Label } from "flowbite-react";
import axiosInstance from "../utils/axiosInstance";
import CopyButton from "./CopyButton";
import TextInput from "./TextInput";
import useTheme from "../contexts/ThemeContext";
import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";

const INITIAL_PASSWORD = "********************************";

const HiddenText = ({ value, isRevealed, onChange }) => {
  const [theme, setTheme] = useState(useTheme());
  return (
    <div>
      <div className="flex space-x-5 align-middle">
        <TextInput
          enabled={false}
          value={isRevealed ? value : INITIAL_PASSWORD}
          className={"w-1/2"}
        />
        {isRevealed && (
          <CopyButton textToCopy={isRevealed ? value : INITIAL_PASSWORD} />
        )}
        <button onClick={onChange}>
          {isRevealed ? (
            <Tooltip title="Hide key">
              <IconButton>
                <FaEyeSlash />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Show key">
              <IconButton>
                <FaEye />
              </IconButton>
            </Tooltip>
          )}
        </button>
      </div>
    </div>
  );
};

export default HiddenText;
